import { ReactElement } from 'react';

import { TherapeuticGroupScheduleDaySimple } from '@dreryk/egabinet-group-session-frontend-api';

import {
   IconFillColor,
   IconSize,
   IconWrapper,
   MoreIconHorizontal,
   StrongText,
   StyledFlex,
   Tooltip,
   TooltipLabel,
} from '@dreryk/react-components';
import { addressFormatter } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

import { StyledServiceProvidingLocationCellTooltip } from './ServiceProvidingLocationCellTooltip.styled';
import { useUniqueLocations } from './ServiceProvidingLocationCellTooltip.hooks';

type ServiceProvidingLocationCellTooltipProps = {
   scheduleDays: TherapeuticGroupScheduleDaySimple[];
};

export const ServiceProvidingLocationCellTooltip = (
   props: ServiceProvidingLocationCellTooltipProps
): ReactElement | null => {
   const uniqueLocations = useUniqueLocations(props.scheduleDays);

   return (
      <StyledFlex direction={'column'} justifyContent={'center'}>
         <Tooltip
            testId={'moreLocationsAvailable'}
            content={
               <StyledFlex gap={'4px'} direction={'column'}>
                  <TooltipLabel label={translationKeys.serviceProvidingLocation} />
                  {uniqueLocations.map((location) => (
                     <StyledFlex key={location.serviceLocationId.asString()} direction={'column'} width={'100%'}>
                        <StrongText testId={'locationName'}>{location.name}</StrongText>
                        <span>{addressFormatter(location.address)}</span>
                     </StyledFlex>
                  ))}
               </StyledFlex>
            }
         >
            <StyledServiceProvidingLocationCellTooltip alignItems={'center'} justifyContent={'center'}>
               <IconWrapper testId={'moreLocationsAvailable'} fillColor={IconFillColor.WHITE} size={IconSize.SMALLEST}>
                  <MoreIconHorizontal />
               </IconWrapper>
            </StyledServiceProvidingLocationCellTooltip>
         </Tooltip>
      </StyledFlex>
   );
};
